<template>
  <div @click="column.click(row)" class="column-moeda">
    <div>
      <span v-if="column.field === 'valorSolicitado'" class="title">Valor Solicitado</span>
      <span v-if="column.field !== 'valorSolicitado'" class="title">{{column.title}}</span>
    </div>
    <span class="align" v-if="column.style">{{price}}<el-link :underline="false"><i class="el-icon-arrow-right"></i></el-link></span>
    <span v-else>{{price}}</span>
  </div>
</template>

<script>
import { float2Money } from '@/utils/dinheiro'

export default {
  name: 'MoedaItem',
  props: ['column', 'row'],
  computed: {
    price () {
      return this.row[this.column.field] ? float2Money(this.row[this.column.field], this.column.decimals, this.column.cifra) : '-'
    }
  }
}
</script>
